import { createAsyncThunk } from '@reduxjs/toolkit';

import { partnerAPI } from '@/modules/partner/api';
import { namespace } from '@/modules/partner/namespace';
import { getPartner } from '@/modules/partner/store/selectors';
import type { RootState } from '@/root-store';
import { ThunkResult } from '@/shared/actions/thunk-result';
import { ISubmitFormResult } from '@/shared/models/formSubmit';

import { updatePartner } from '../actions';

let lastRequestId: string | undefined;

const updateIsVehiclesHidden = createAsyncThunk<
  ThunkResult<ISubmitFormResult<{ isVehiclesHidden: boolean }>>,
  { isVehiclesHidden: boolean }
>(`${namespace}/update-vehicles-hidden`, async (formValues, { dispatch, requestId, getState }) => {
  try {
    if (lastRequestId !== undefined) {
      return { isAlreadyExecuted: true };
    }

    lastRequestId = requestId;

    const partner = getPartner(getState() as RootState);

    const result = await partnerAPI.updateIsVehiclesHidden({
      ...partner,
      isVehiclesHidden: formValues.isVehiclesHidden,
    });

    await dispatch(
      updatePartner({
        isVehiclesHidden: formValues.isVehiclesHidden,
      }),
    );

    return {
      isSucceed: true,
      result,
    };
  } finally {
    lastRequestId = undefined;
  }
});

export { updateIsVehiclesHidden };
